module.exports = __webpack_public_path__ + "img/culture1.0164d1ba.jpg";